// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"67ff12b7","977":"a5ebcacc"}[chunkId] + ".chunk.js");